import { EmptyReferencePatent } from '../constants';
import { ANCS_TYPE } from '../enums';
import { type ReferencePatent } from '../types';

/**
 * 是否是参考专利信息空对象
 * @param referencePatent
 * @returns
 */
export function isEmptyReferencePatent(referencePatent: ReferencePatent): boolean {
    return referencePatent === EmptyReferencePatent;
}

/**
 * 创建参考专利信息
 * @param patentNo 专利号
 * @returns
 */
export function createReferencePatent(patentNo: string, customTitle?: string): ReferencePatent {
    const record: ReferencePatent = {
        patentNo,
        title: customTitle ?? `[${patentNo}]`,
        description: '',
        patentId: '',
        iconUrl: '',
        ancs: ['-'],
        ancsType: ANCS_TYPE.PERSON,
    };
    return record;
}
